/**
 * The working-hours field governs nothing: presence is entirely manual (the
 * online toggle, plus auto-online at socket connect). Nothing in the backend
 * reads availability.workingHours — it is published information only. Say so
 * explicitly wherever the field is shown, so a consultant doesn't believe they
 * have scheduled their availability.
 */
export const WORKING_HOURS_DISCLAIMER =
  'Questi orari sono solo informativi: compaiono sul tuo profilo pubblico ma ' +
  'non ti mettono online né offline in automatico. Per farti trovare ' +
  'disponibile devi usare il tasto "Vai online".';

export const WORKING_HOURS_DISCLAIMER_PUBLIC =
  'Orari indicativi dichiarati dal consulente. La disponibilità reale è quella ' +
  'indicata dal suo stato (online / offline).';

export const WORKING_HOURS_DISCLAIMER_ADMIN =
  'Campo informativo: non governa presenza né auto-online.';

export function WorkingHoursNotice({
  variant = 'consultant',
  className = '',
}: {
  variant?: 'consultant' | 'public' | 'admin';
  className?: string;
}) {
  const text =
    variant === 'public'
      ? WORKING_HOURS_DISCLAIMER_PUBLIC
      : variant === 'admin'
        ? WORKING_HOURS_DISCLAIMER_ADMIN
        : WORKING_HOURS_DISCLAIMER;

  const tone =
    variant === 'consultant'
      ? 'rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800'
      : variant === 'public'
        ? 'border-t border-white/10 pt-3 text-xs text-white/50'
        : 'text-xs text-neutral-400';

  return (
    <p role="note" className={`${tone} ${className}`.trim()}>
      {text}
    </p>
  );
}
